import { useEffect, useRef, useState } from 'react'
import { colors } from '../../data/colors'

const ColorPicker = ({ color, onChange }: { color: string; onChange: (color: string) => void }) => {
    const pickerRef = useRef<HTMLDivElement>(null)
    const [isOpen, setIsOpen] = useState(false)

    // Fecha o dropdown ao clicar fora
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (pickerRef.current && !pickerRef.current.contains(event.target as Node)) {
                setIsOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    return (
        <div className='relative inline-block' ref={pickerRef}>
            {/* Botão para abrir o seletor de cores */}
            <div
                className='w-10 h-10 rounded-full cursor-pointer hover:opacity-80'
                style={{ backgroundColor: color }}
                onClick={() => setIsOpen(!isOpen)}
            />

            {/* Dropdown de cores */}
            {isOpen && (
                <div className='absolute mt-2 w-72 bg-white dark:bg-gray-800 border dark:border-gray-600 shadow-lg rounded-xl p-2 md:p-4 grid grid-cols-4 md:grid-cols-6 gap-2 z-10'>
                    {colors.map(c => (
                        <div
                            key={c}
                            className='w-8 h-8 rounded-full cursor-pointer hover:opacity-80'
                            style={{ backgroundColor: c }}
                            onClick={() => {
                                onChange(c)
                                setIsOpen(false)
                            }}
                        />
                    ))}
                </div>
            )}
        </div>
    )
}

export default ColorPicker
